module.exports = __webpack_public_path__ + "img/img32.0b92931a.svg";